(() => {
  if (window.__pqInlineSearchInitialized) return;

  window.__pqInlineSearchInitialized = true;

  const desktopMedia = window.matchMedia('(min-width: 1024px)');
  const popup = document.querySelector('[data-search-popup]');
  const desktopTrigger = document.querySelector('.m-header__desktop [data-open-search-popup]');
  const headerRight = document.querySelector('.m-header__top .m-header__right');
  let openedAtScrollY = 0;

  if (!popup || !desktopTrigger || !headerRight) return;

  popup.classList.add('pq-inline-search');

  const getControllers = () =>
    Array.from(document.querySelectorAll('m-search-popup')).filter(
      (controller) => typeof controller.closeSearchPopup === 'function'
    );

  const isDesktopOpen = () =>
    desktopMedia.matches &&
    popup.style.visibility !== 'hidden' &&
    popup.querySelector('[data-search-container]')?.classList.contains('m-show-search');

  const positionPopup = () => {
    if (!desktopMedia.matches) return;

    const triggerRect = desktopTrigger.getBoundingClientRect();
    const headerRightRect = headerRight.getBoundingClientRect();
    const viewportPadding = 24;
    const right = Math.min(triggerRect.right, window.innerWidth - viewportPadding);
    let left = Math.max(headerRightRect.left, viewportPadding);

    if (right - left < 520) left = Math.max(viewportPadding, right - 620);

    popup.style.setProperty('--pq-search-left', `${Math.round(left)}px`);
    popup.style.setProperty('--pq-search-top', `${Math.round(triggerRect.top)}px`);
    popup.style.setProperty('--pq-search-width', `${Math.round(right - left)}px`);
  };

  const decorateSuggestions = () => {
    const popular = popup.querySelector('[data-popular-searches]');
    if (!popular) return;

    popular.classList.add('pq-inline-search__suggestions');
    const label = popular.querySelector('.m-search-popular--label');
    if (label) label.textContent = 'Sugestii de căutare';

    popular.querySelectorAll('[data-ps-item]').forEach((item) => {
      const query = item.textContent.trim();
      const searchPath = window.MinimogSettings?.routes?.search_url || '/search';

      if (!item.getAttribute('href')) item.href = `${searchPath}?q=${encodeURIComponent(query)}`;
      if (item.querySelector('.pq-inline-search__suggestion-icon')) return;

      const icon = document.createElement('span');
      icon.className = 'pq-inline-search__suggestion-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML =
        '<svg viewBox="0 0 20 20" fill="none"><circle cx="8.7" cy="8.7" r="5.7" stroke="currentColor" stroke-width="1.6"/><path d="m13 13 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      item.prepend(icon);
    });
  };

  const handleDesktopOpen = () => {
    if (!desktopMedia.matches) return;

    openedAtScrollY = window.scrollY;
    positionPopup();
    decorateSuggestions();
    document.documentElement.classList.remove('prevent-scroll');
    document.documentElement.classList.add('pq-inline-search-open');
  };

  const closeDesktopSearch = () => {
    if (!isDesktopOpen()) return;

    getControllers().forEach((controller) => {
      if (controller.hasAttribute('open')) controller.closeSearchPopup();
    });

    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.closeSearchPopup) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.closeSearchPopup);
    }

    document.documentElement.classList.remove('prevent-scroll', 'pq-inline-search-open');
  };

  desktopTrigger.addEventListener('click', () => {
    window.requestAnimationFrame(handleDesktopOpen);
  });

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!isDesktopOpen()) return;
      if (popup.contains(event.target) || desktopTrigger.contains(event.target)) return;

      closeDesktopSearch();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDesktopSearch();
  });

  window.addEventListener(
    'scroll',
    () => {
      if (isDesktopOpen() && Math.abs(window.scrollY - openedAtScrollY) > 8) closeDesktopSearch();
    },
    { passive: true }
  );

  window.addEventListener('resize', () => {
    if (isDesktopOpen()) positionPopup();
  });

  if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.openSearchPopup) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openSearchPopup, handleDesktopOpen);
  }

  decorateSuggestions();
})();
